// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"limitGame__pageWrapper__STljv","infoBlock":"limitGame__infoBlock__3I7FD"};